import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { AppProvider } from './lib/store';

// NOTE: do not request persistent storage here. Firefox answers
// navigator.storage.persist() with a modal permission dialog, and firing it
// at startup asks a stranger for a permission they have no context for,
// which mostly earns a "Block" that is then hard to undo. The request is
// made only from an explicit tap, after the app has explained itself
// (see components/PersistCard.tsx and DataSafetySection).

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);

// PWA: register the service worker (production builds only).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // offline support is progressive enhancement; app works without it
    });
  });
}
